import { render, staticRenderFns } from "./conversation-list.vue?vue&type=template&id=71a63ec6&scoped=true"
import script from "./conversation-list.vue?vue&type=script&lang=ts"
export * from "./conversation-list.vue?vue&type=script&lang=ts"
import style0 from "./conversation-list.vue?vue&type=style&index=0&id=71a63ec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a63ec6",
  null
  
)

export default component.exports